// Handle analytics script after static page load (WP Fastest Cache or WP Super Cache) //

function enableGTM(gtmCode) {
  document.querySelectorAll('.sp-cookies.gtm').forEach((script) => {
    script.type = 'text/javascript';

    // eslint-disable-next-line no-eval
    eval(script.innerHTML);
  });

  // Inject noscript iframe manually
  if (gtmCode) {
    const gtmIframe = document.createElement('iframe');

    gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmCode}`;
    gtmIframe.height = '0';
    gtmIframe.width = '0';

    document.body.appendChild(gtmIframe);
  }
}

function getGTMCode() {
  const script = document.querySelector('.sp-cookies.gtm');

  if (!script) {
    return null;
  }

  const match = script.innerHTML.match(/'GTM-[^']+'/);

  return match ? match[0].replace(/'/g, '') : null;
}

function enableGA4(gaCode) {
  document.querySelectorAll('.sp-cookies.ga').forEach((script) => {
    script.type = 'text/javascript';

    // eslint-disable-next-line no-eval
    eval(script.innerHTML);
  });

  // Load Google Analytics library
  const gaScript = document.createElement('script');

  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaCode}`;

  document.head.appendChild(gaScript);
}

function getGACode() {
  const script = document.querySelector('.sp-cookies.ga');

  if (!script) {
    return null;
  }

  const match = script.innerHTML.match(/'G-[^']+'/);

  return match ? match[0].replace(/'/g, '') : null;
}

if (!document.body.classList.contains('preview')) {
  window.addEventListener('DOMContentLoaded', () => {
    const gtmScripts = document.querySelectorAll('.sp-cookies.gtm');
    const gaScripts = document.querySelectorAll('.sp-cookies.ga');

    if (!Cookies.get('performance_cookie')) {
      return;
    }

    if (gtmScripts.length) {
      const gtmCode = getGTMCode();

      if (gtmCode) {
        loadScripts(gtmScripts);
        enableGTM(gtmCode);
      }
    }

    if (gaScripts.length) {
      const gaCode = getGACode();

      if (gaCode) {
        enableGA4(gaCode);
      }
    }
  });

  const loadScripts = (scripts) => {
    scripts.forEach((script) => {
      script.type = 'text/javascript';

      document.head.appendChild(script);
    });
  };
}

// ************************************************************
// GTM / GA4 - Consent Default
// ************************************************************

const initConsentDefault = () => {
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });
};

const updateConsent = () => {
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  const performanceCookie = Cookies.get('performance_cookie');
  const advertisingCookie = Cookies.get('advertising_cookie');

  gtag('consent', 'update', {
    analytics_storage: performanceCookie ? 'granted' : 'denied',
    ad_storage: advertisingCookie ? 'granted' : 'denied',
    ad_user_data: advertisingCookie ? 'granted' : 'denied',
    ad_personalization: advertisingCookie ? 'granted' : 'denied',
  });
};

initConsentDefault();
updateConsent();
